import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, ViewChild } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { GitHelper } from '../../../helpers/git.helper';
import { PermissionHelper } from '../../../helpers/permissions.helper';
import { LayoutService } from '../../../services/layout.service';
import { MediaService } from '../../../services/media.service';
import { UsersService } from '../../../services/users.service';
import { AboutControl } from '../../common/aboutcontrol/about.control';
import { IBaseComponent } from '../base.component';

@Component({
    selector: 'evi-user-menu',
    templateUrl: 'usermenu.control.html',
    styleUrls: ['usermenu.control.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserMenuControl extends IBaseComponent {

    static Type: any = 'usermenu';
    static Default = {
        Editable: true,
        Type: 'usermenu'
    };
    static Meta = {
                Type: 'usermenu',
                Properties: [
                ],
                Events: [
                ]
            };
    user;
    AllowImpersonate = false;
    URL: string;
    GitActive = false;
    Branches = [];
    SelectedBranch;
    @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;
    get Icon() {
        if (this.LayoutElement.Icon) {
            return this.LayoutElement.Icon;
        }
        return "person";
    }
    constructor(private usersService: UsersService, cdRef: ChangeDetectorRef, @Inject(LayoutService.CONTAINER_DATA) public data) {
        super(cdRef, data);
    }

    ControlInitialized() {
        this.GitActive = GitHelper.IsActive;
        if (this.GitActive) {
            this.Branches = GitHelper.LocalBranches;
            this.Subscriptions['BranchesChanged'] = GitHelper.BranchesChanged.subscribe((branches) => {
                this.Branches = GitHelper.LocalBranches;
                this.cdRef.detectChanges();
            });
            this.SelectedBranch = GitHelper.SelectedBranch;
        }
        this.user = localStorage.getItem('user');
        if (this.user) {
            this.user = JSON.parse(this.user);
            this.updateImage();
        }
        this.AllowImpersonate = PermissionHelper.GetImpersonatePermission();
    }
    SelectedBranchChanged() {
        GitHelper.SelectedBranch.next(this.SelectedBranch);
    }
    logout() {
        this.usersService.logout();
        this.trigger.closeMenu();
    }

    updateImage() {
        if (this.user && this.user.Image) {
            const url = MediaService.ProfilePicURL.getValue();
            if (url) {
                this.URL = url + this.user.SID + '/' + this.user.Image;
            }
        }
    }

    languageSelected() {
        // const text = '@@Bitte denken Sie daran auch die Spracheneinstellung Ihres Browsers anzupassen. Einige Controls (z.B.DatetimePicker) und Formatierungen verhalten sich sonst moeglicherweise nicht wie erwartet.';
        // MessageBoxHelper.ShowDialog(new TranslateFormatText(text), null, MessageBoxButtons.Ok, MessageBoxIcon.Information);
    }

    OpenDialog() {
        AboutControl.ShowDialog();
        this.trigger.closeMenu();
    }
}
